var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoopNode__container"},[_c('h4',[_vm._v("Loop")]),_c('v-text-field',{staticClass:"LoopNode__input",attrs:{"label":_vm.loopText,"outlined":"","dense":"","hide-details":true,"value":_vm.iteration},on:{"input":_vm.onInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }